import React from 'react';
import { Col } from 'react-bootstrap';
import '../styles/Skill.css'

export default function Skill({ name, percentage, image }) {
    return (
        <Col lg={3} md={4} sm={6} xs={12}>
            <div className='skill-box'>
                <div className="image-box">
                    <img src={image} height='100px' alt={name} />
                </div>
                <div className="text-box">
                    <h4>{name}</h4>
                    <div className='percentage-bar'>
                        <div style={{width: `${percentage}%`}} className="percentage-fill">
                            <small className="percentage-text">{percentage}%</small>
                        </div>
                    </div>
                </div>
            </div>
        </Col>
    );
};